import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter, NavLink } from 'react-router-dom';
import { Divider, Switch } from 'antd';
import 'antd/dist/antd.css';
import './Header.css';
import PropTypes from 'prop-types';
import { fetchUserDetails } from '../../Pages/Login/Login.saga';
import { logoutUpdate } from '../../Pages/Login/Login.reducer';
import UserDropdown from '../UserDropdown/UserDropdown';
import { toggleRedundantViews } from '../../Common/common.reducer';
import { isEmpty } from '../../Utils/validationUtil';

function Header({
  location,
  match,
  modelDetails,
  userDetails,
  toggleRedundantViewsAction,
  fetchUserDetailsAction,
  logoutUpdateAction,
  showRedundantViews,
  inferenceDetails,
  runtimeHistoryDetails,
  history,
}) {
  const [tabs, setTabs] = useState(null);
  const [modelName, setModelName] = useState('');
  const [type, setType] = useState('');
  const [inferenceName, setInferenceName] = useState('');

  useEffect(() => {
    fetchUserDetailsAction();
  }, [fetchUserDetailsAction]);

  useEffect(() => {
    const { pathname } = location;
    const { modelName: modelDName, modelTypeName, modelType } = modelDetails;
    const { inferenceName: inferenceDName, modelLearningMode } =
      inferenceDetails;
    const { modelName: historyModelName, learningType } = runtimeHistoryDetails;
    if (
      pathname === '/model-list' ||
      pathname === '/model-archive' ||
      pathname === '/administration'
    ) {
      setTabs(true);
    } else {
      setTabs(false);
    }
    if (!isEmpty(modelDetails)) {
      setModelName(modelDName);
      setType(
        (modelTypeName === 'Supervised' ? 'Guided' : 'Auto') ||
          (modelType === 'Supervised' ? 'Guided' : 'Auto')
      );
    }
    if (!isEmpty(inferenceDetails)) {
      setInferenceName(inferenceDName);
      setType(modelLearningMode);
    }
    if (!isEmpty(runtimeHistoryDetails)) {
      setModelName(historyModelName);
      setType(learningType);
    }
  }, [location, modelDetails, inferenceDetails, runtimeHistoryDetails]);

  const homeScreen = () => {
    history.push('/');
  };

  const logoutUser = () => {
    logoutUpdateAction();
    homeScreen();
  };

  const backAction = () => {
    const {
      params: { modelId },
    } = match;
    const { pathname } = location;
    if (
      pathname.indexOf('model-list') > 0 &&
      pathname.indexOf('inference') > 0
    ) {
      history.push(`/model-list/${modelId}/runtime-history`);
    } else {
      history.push('/model-list');
    }
  };

  return (
    <div className="header">
      <div className="leftHeaderContent">
        <div className="logoHolder" onClick={homeScreen} />
        <Divider
          type="vertical"
          className="verticalDividerRight"
          style={{
            marginTop: '28px',
          }}
        />
        {tabs ? (
          <div
            style={{
              display: 'flex',
            }}
          >
            <NavLink
              activeClassName="linkActive"
              className="tabItemContainer"
              to="/model-list"
            >
              Models
            </NavLink>
            {showRedundantViews &&
              userDetails &&
              userDetails.roleName !== 'Operator' && (
                <NavLink
                  activeClassName="linkActive"
                  className="tabItemContainer"
                  to="/model-archive"
                >
                  Archive Models
                </NavLink>
              )}
            {userDetails && userDetails.roleName !== 'Operator' && (
              <NavLink
                activeClassName="linkActive"
                className="tabItemContainer"
                to="/administration"
              >
                Administration
              </NavLink>
            )}
          </div>
        ) : (
          <div className="pageHeader">
            <span className="flaticon-arrow" onClick={backAction} />
            <span className="titleContainer">
              <span className="titleContainer">
                <span className="subHeading">Model</span>
                <span
                  style={{
                    display: 'flex',
                  }}
                >
                  <span className="modelNameContainer">
                    {modelName}
                    <span className="modelToolTip">{modelName}</span>
                  </span>
                  <span
                    className="typeContainer"
                    style={{
                      margin: '3px 0 0 5px',
                    }}
                  >
                    {' '}
                    - {type}
                  </span>
                </span>
              </span>
            </span>
            {location.pathname.indexOf('model-list') > 0 &&
              location.pathname.indexOf('inference') > 0 && (
                <Divider
                  style={{
                    marginTop: '15px',
                  }}
                  type="vertical"
                  className="verticalDividerRight"
                />
              )}
            {location.pathname.indexOf('model-list') > 0 &&
              location.pathname.indexOf('inference') > 0 && (
                <span className="titleContainer">
                  <span className="subHeading">Runtime</span>
                  <span
                    style={{
                      display: 'flex',
                    }}
                  >
                    <span className="modelNameContainer">
                      {inferenceName}
                      <span className="modelToolTip">{inferenceName}</span>
                    </span>
                  </span>
                </span>
              )}
          </div>
        )}
      </div>
      <div className="rightHeaderContent">
        <Switch
          checked={showRedundantViews}
          className="headerSwitch"
          onChange={() => toggleRedundantViewsAction()}
        />
        {/* <span className="helpSpan">
          <Icon type="question-circle" theme="filled" className="infoIcon" />
          Help
        </span> */}
        {/* <Divider type="vertical" className="verticalDividerRight" /> */}
        <UserDropdown
          logoutUser={logoutUser}
          // updateUserDetails={updateUserDetails}
          userDetails={userDetails}
        />
      </div>
    </div>
  );
}

Header.defaultProps = {
  modelDetails: {},
  userDetails: {},
  location: {
    pathname: '',
  },
  match: {
    params: {},
  },
  toggleRedundantViewsAction: (f) => f,
  fetchUserDetailsAction: (f) => f,
  logoutUpdateAction: (f) => f,
  history: {
    push: (f) => f,
  },
  showRedundantViews: false,
  inferenceDetails: {},
  runtimeHistoryDetails: {},
};

Header.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  match: PropTypes.shape({
    params: PropTypes.instanceOf(Object),
  }),
  modelDetails: PropTypes.instanceOf(Object),
  userDetails: PropTypes.instanceOf(Object),
  toggleRedundantViewsAction: PropTypes.func,
  fetchUserDetailsAction: PropTypes.func,
  logoutUpdateAction: PropTypes.func,
  showRedundantViews: PropTypes.bool,
  inferenceDetails: PropTypes.instanceOf(Object),
  runtimeHistoryDetails: PropTypes.instanceOf(Object),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

export default withRouter(
  connect(
    (state) => ({
      userDetails: state.loginReducer.userDetails,
      modelDetails: state.loginReducer.modelDetails,
      showRedundantViews: state.commonReducer.showRedundantViews,
      inferenceDetails: state.inferenceReducer.entity,
      runtimeHistoryDetails:
        state.runtimeHistoryReducer && state.runtimeHistoryReducer.entity,
    }),
    {
      logoutUpdateAction: logoutUpdate,
      fetchUserDetailsAction: fetchUserDetails,
      toggleRedundantViewsAction: toggleRedundantViews,
    }
  )(Header)
);
